import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";

import { Comment as SemanticComment } from "semantic-ui-react";

class Comment extends Component {
  camelCaseToTitleCase(str) {
    return str
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .trim();
  }

  formatCommentText(text) {
    try {
      const parsed = JSON.parse(text);
      if (typeof parsed === 'object' && parsed !== null) {
        if (Array.isArray(parsed)) {
          // Format top-level array as comma-separated strings
          const stringItems = parsed.filter(item => typeof item === 'string');
          return stringItems.join(', ');
        } else {
          // Format object with all top-level properties
          return Object.entries(parsed)
            .map(([key, value]) => {
              const titleCaseKey = this.camelCaseToTitleCase(key);
              if (Array.isArray(value)) {
                const stringItems = value.filter(item => typeof item === 'string');
                return { key: titleCaseKey, value: stringItems.join(', ') };
              } else if (typeof value === 'object' && value !== null) {
                // Special case for estimatedPriceRange
                if (key === 'estimatedPriceRange' && value.text) {
                  return { key: titleCaseKey, value: value.text };
                }
                // Special case for estimateTime
                if (key === 'estimateTime' && value.display) {
                  return { key: titleCaseKey, value: value.display };
                }
                // Skip other objects
                return null;
              }
              return { key: titleCaseKey, value: value };
            })
            .filter(item => item !== null);
        }
      }
    } catch (e) {
      // Not valid JSON, return original text
    }
    return text;
  }

  render() {
    let { comment } = this.props;
    const formattedComment = this.formatCommentText(comment.comment);
    
    return (
      <SemanticComment>
        <SemanticComment.Content>
          <SemanticComment.Author>
            {comment.author}
            <SemanticComment.Metadata>
              <div>{moment(comment.DateAdded).format("LLL")}</div>
            </SemanticComment.Metadata>
          </SemanticComment.Author>
          <SemanticComment.Text style={{ whiteSpace: 'pre-line' }}>
            {Array.isArray(formattedComment) ? (
              formattedComment.map((item, index) => (
                <div key={index}>
                  {item.key}: <strong>{item.value}</strong>
                </div>
              ))
            ) : (
              formattedComment
            )}
          </SemanticComment.Text>
        </SemanticComment.Content>
      </SemanticComment>
    );
  }
}

Comment.defaultProps = {
  comment: {}
};

Comment.propTypes = {
  user: PropTypes.object
};

export default Comment;
